export class PlaybooksSettings {
  notifyOnCompletion: boolean;

  constructor(data: any) {
    this.notifyOnCompletion = data.notifyOnCompletion;
  }
}
